export enum BroadcastQuality {
    High = 'high',
    Medium = 'medium',
    Low = 'low'
}

/** Fallback when no whitelabel value / store value is available. High preserves today's behavior (1280x720 @ 4 Mbit). */
export const DEFAULT_BROADCAST_QUALITY = BroadcastQuality.High;

/** Normalizes a whitelabel/env string into a BroadcastQuality, falling back to the default for anything unrecognized. */
export const parseBroadcastQuality = (value: string | null | undefined): BroadcastQuality => {
    switch ((value ?? '').trim().toLowerCase()) {
        case 'high':
            return BroadcastQuality.High;
        case 'medium':
            return BroadcastQuality.Medium;
        case 'low':
            return BroadcastQuality.Low;
        default:
            return DEFAULT_BROADCAST_QUALITY;
    }
};

export interface Rect {
    x: number;
    y: number;
    width: number;
    height: number;
}

/** Scales a rect defined in a `fromWidth`-wide reference space into a `toWidth`-wide space, uniformly (assumes same aspect ratio). */
export const scaleRect = (rect: Rect, fromWidth: number, toWidth: number): Rect => {
    const factor = toWidth / fromWidth;
    return {
        x: rect.x * factor,
        y: rect.y * factor,
        width: rect.width * factor,
        height: rect.height * factor
    };
};
